module.exports = __webpack_public_path__ + "img/ch57.f0ac1649.png";